import { render, staticRenderFns } from "./HaloSupportBox.vue?vue&type=template&id=ccc29778&"
import script from "./HaloSupportBox.vue?vue&type=script&lang=ts&"
export * from "./HaloSupportBox.vue?vue&type=script&lang=ts&"
import style0 from "./HaloSupportBox.vue?vue&type=style&index=0&id=ccc29778&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports